import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Produit } from 'src/app/shared/models/produit';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-edit-parametrage-produits',
  templateUrl: './edit-parametrage-produits.component.html',
  styleUrl: './edit-parametrage-produits.component.scss'
})

export class EditParametrageProduitsComponent {
  item: Produit = new Produit();
  departementItems: any;
  categorieProduitItems: any;
  uniteItems: any;
  etatProduitItems: any;
  items: any =[];
  varieteItems: any;
  photoPreview: string | ArrayBuffer | null = null;
  visible: boolean = false;
  reference:any;

  position: string = 'center';
  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private ngxservice: NgxUiLoaderService

  ) { }



  ngOnInit() {
    this.items = this.localStorage.getProduit();
    this.item = this.localStorage.getProduit();
    console.log("this.items", this.items);
    this.photoPreview = this.localStorage.getProduit()?.image;
    this.item.image=null
    this.getCategorieProduit();
    this.reference = this.localStorage.getUsers().data;

  }



  close() {

    this.modalService.dismissAll();
  }

  updateProduit() {
    // if (!this.item.canSave()) {
    //   this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: this.item.getErrorMessage() });
    //   return;
    // } 
   // else {
      this.ngxservice.start();

      // Récupérer les accessoires sélectionnés
      const accessoiresSelectionnes = this.uniteItems
        .filter((item: any) => item.accessoire_machine_id) // Vérifie les cases cochées
        .map((item: any) => item.id); // Récupère les identifiants

      // Créer l'objet FormData
      let formData: FormData = new FormData();
      formData.append('nom', this.item.nom);
      formData.append('unite_mesure_id', this.item.unite_mesure_id);
      formData.append('etat_produit_id', this.item.etat_produit_id);
      formData.append('categorie_produit_id', this.item.categorie_produit_id);
      formData.append('variete_produit_id', this.item.variete_produit_id);
      formData.append('image', this.item.image);

      formData.append('produit_id', this.items.reference);
      formData.append('user_id', this.reference.reference);

      // Envoyer la requête
      this.paramService.editProduit(formData).subscribe(
        (response: any) => {
          this.ngxservice.stop();
          this.modalService.dismissAll();
          this.messageService.add({
            severity: 'success',
            summary: "AfriCereal",
            detail: response.message,
          });
          this.fecthDataService.notifySeriviceCreated();
        },
        (error: any) => {
          this.ngxservice.stop();
          this.messageService.add({
            severity: 'error',
            summary: "AfriCereal",
            detail: error,
          });
        }
      );
  //  }
  }

  showDialog(position: string) {
    this.position = position;
    this.visible = true;
  }
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.item.image = file;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.photoPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  getCategorieProduit() {
    this.paramService.getCategorieProduit().subscribe(
      (response: any) => {
        this.categorieProduitItems = response.data;
        console.log("categorieProduitItems", this.categorieProduitItems);
        // this.item.categorie_produit_id = this.categorieProduitItems.find(
        //   (item: any) => item.id === this.items?.medecin_agree?.id
        // );
        //
         this.getUniteMesure();
      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }

  getUniteMesure() {
    this.paramService.getUniteMesure().subscribe(
      (response: any) => {
        this.uniteItems = response.data;
        console.log("uniteItems", this.uniteItems);
        this.getEtat();
      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }
  getEtat() {
    this.paramService.getEtatProduit().subscribe(
      (response: any) => {
        this.etatProduitItems = response.data;
        console.log("etatProduitItems", this.etatProduitItems);
        this.getVarieteProduit()

      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }

  getVarieteProduit() {
    this.paramService.getVarieteProduit().subscribe(
      (response: any) => {
        this.varieteItems = response.data;
        console.log("varieteItems", this.varieteItems);

      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }
}
